import type { DocumentCategory } from "@/adapters/api";

export const DOCUMENT_CATEGORY_LABELS: Record<DocumentCategory, string> = {
	projects: "Projetos",
	art_rrt: "ART/RRT",
	reports: "Laudos",
	contracts: "Contratos",
	permits: "Licenças e Alvarás",
	other: "Outros",
};

export const DOCUMENT_CATEGORIES = Object.keys(
	DOCUMENT_CATEGORY_LABELS,
) as DocumentCategory[];

export function isDocumentCategory(value: unknown): value is DocumentCategory {
	return (
		typeof value === "string" &&
		(DOCUMENT_CATEGORIES as string[]).includes(value)
	);
}

export function documentCategoryLabel(category: DocumentCategory): string {
	return DOCUMENT_CATEGORY_LABELS[category];
}
